import { useEffect } from 'react';
import fscreen from 'fscreen';

export function useFullscreenEvents({
  enabled,
  onFullscreenEntered,
  onFullscreenExited,
}: {
  onFullscreenEntered?: () => void;
  onFullscreenExited?: () => void;
  enabled: boolean;
}) {
  useEffect(() => {
    if ((!onFullscreenEntered && !onFullscreenExited) || !enabled) {
      return;
    }

    const handleFullscreenChange = () => {
      if (fscreen.fullscreenElement) {
        onFullscreenEntered && onFullscreenEntered();
        return;
      }
      onFullscreenExited && onFullscreenExited();
    };

    fscreen.addEventListener('fullscreenchange', handleFullscreenChange);
    return () =>
      fscreen.removeEventListener('fullscreenchange', handleFullscreenChange);
  }, [enabled, onFullscreenEntered, onFullscreenExited]);
}
